
function xmlParserGetFilterExtraData(xmlData) {
    var extraDataList = []

    const extraDataListXml = xmlData.getElementsByTagName('extraData');
    extraDataListXml.map((extraData) => {
        var name = extraData.getElementsByTagName('name')[0].value;
        var id = extraData.getElementsByTagName('id')[0].value;
        var subExtraDataListXml = extraData.getElementsByTagName('data');
        var subExtraDataList = []
        subExtraDataListXml.map((subExtraData) => {
            var subName = subExtraData.getElementsByTagName('value')[0].value;
            var subId = subExtraData.getElementsByTagName('idData')[0].value;
            var subExtraData = {
                name: subName,
                id: subId,
            }
            subExtraDataList.push(subExtraData);
        })

        var item = {
            name: name,
            id: id,
            subExtraDataList: subExtraDataList
        }
        extraDataList.push(item);
    })
    return [extraDataList];
}

export default xmlParserGetFilterExtraData;